import { render, staticRenderFns } from "./EditVendor.vue?vue&type=template&id=3877e68c&scoped=true"
import script from "./EditVendor.vue?vue&type=script&lang=js"
export * from "./EditVendor.vue?vue&type=script&lang=js"
import style0 from "./EditVendor.vue?vue&type=style&index=0&id=3877e68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877e68c",
  null
  
)

export default component.exports